import * as types from '../mutation-types';
import { changeValueType } from '../data-reformer';
import { valueTypes } from '@/helpers/enums';
const state = {
    settings:[],
	globalSettings: []
}

const actions = {
	fetchFinancialFileSettings({ commit }, id){
		return window.axios.get(`Settings/${id}/FinancialfileId`).then( ({data}) => {
			data.forEach((setting) =>{
				setting.setting_value = changeValueType(setting.setting_value, setting.type)
			})
			commit(types.STORE_SETTINGS, data)
			return data
		})
	},
	updateFinancialFileSettings(_, {setting, id}) {
		const updateSetting = JSON.parse(JSON.stringify(setting));
		/*data format*/
		updateSetting.setting_value = changeValueType(updateSetting.setting_value, valueTypes.string);
		return window.axios.put(`Settings/${id}/financialFile`, updateSetting).then(response => response.data);
	},
	addFinancialFileSettings(_, {setting, id}) {
		const updateSetting = JSON.parse(JSON.stringify(setting));
		/*data format*/
		updateSetting.setting_value = changeValueType(updateSetting.setting_value, valueTypes.string);
		return window.axios.post(`Settings/${id}/financialFile`, updateSetting).then(response => response.data);
	},
	deleteFinancialFileSetting(_, {id, financial_file_id}) {
		return window.axios.delete(`Settings/${id}/financialFile`, {params: {financial_file_id: financial_file_id}}).then(response => response.data)
	},
	fetchGlobalSettings({ commit }) {
		return window.axios.get('Settings').then( ({data}) => {
			/*data format */
			data.forEach((setting) =>{

				setting.setting_value = changeValueType(setting.setting_value,setting.type)
				setting.financial_file_settings_responses.forEach(file => {
					file.setting_value = changeValueType(file.setting_value, file.type)
				})
			})

			commit(types.STORE_GLOBAL_SETTINGS, data)
			return data;
		})
	},
	updateGlobalSettings(_, {setting, id}) {
		const updateSetting = JSON.parse(JSON.stringify(setting));
		/*data format*/
		updateSetting.financial_file_settings_requests.forEach(file => {
				file.setting_value = changeValueType(file.setting_value, valueTypes.string) 
			}
		)
		updateSetting.setting_value = changeValueType(updateSetting.setting_value, valueTypes.string);
		return window.axios.put(`Settings/${id}`, updateSetting)
	},
}

const mutations = {
	[types.STORE_SETTINGS](state, settings) {
		state.settings = settings; 
	},
	[types.STORE_GLOBAL_SETTINGS](state, settings) {
		state.globalSettings = settings;
	}
}

const getters = {
	getSettingByKey: state => key => {
		return state.settings.find(c => c.setting_key === key) 
		|| state.globalSettings.find(c => c.setting_key === key) 
	},
	getGlobalSettingById : state => id => state.globalSettings.find(v => v.id === id)
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}